export default "<div class=\"p-grid\">\n    <div class=\"p-col-12\">\n<br/><br/><br/>\n</div>\n</div>\n\n";